export default "__VITE_PUBLIC_ASSET__9c49f884__"